import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { JPYs, secondaryWorkTypeGroupLengthCount, secondsToHms } from '../common/Common';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { ServiceClass, WorkType } from '../common/enums';
import { join } from 'lodash';

const IQ3KouteiBetsuKesanshiki_BlankPunch = (props) => {
  const [laserProcessInput, setLaserProcessInput] = useState([]);
  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  const [isTwoStepHoleOpen, setIsTwoStepHoleOpen] = useState(true);
  const [isJointOpen, setIsJointOpen] = useState(true);

  const [basicSetupTime, setBasicSetupTime] = useState(0);
  const [basicSetupAmt, setBasicSetupAmt] = useState(0);

  const [moldSetupTime, setMoldSetupTime] = useState(0);
  const [moldSetupAmt, setMoldSetupAmt] = useState(0);
  const [dandoriMoldCnt, setDandoriMoldCnt] = useState(0);

  const [sagyouPunchTime, setSagyouPunchTime] = useState(0);
  const [sagyouPunchAmt, setSagyouPunchAmt] = useState(0);
  const [punchCount, setPunchCount] = useState(0);
  const [productionQuantityCoeff, setProductionQuantityCoeff] = useState(0);
  const [onePunchTime, setOnePunchTime] = useState(0);

  const [sagyoTmAirDeli, setSagyouTmAirDeli] = useState(0);
  const [sagyoAmtAirDeli, setSagyoAmtAirDeli] = useState(0);
  const [speedDeliAirLan, setSpeedDeliAirLan] = useState(0);

  const [speedScribingLen, setSpeedScribingLen] = useState(0);
  const [sagyoTmScribing, setSagyoTmScribing] = useState(0);
  const [sagyoAmtScribing, setSagyoAmtScribing] = useState(0);

  const [twoStepHoleCnt, setTwoStepHoleCnt] = useState(0);
  const [twoStepHoleTime, setTwoStepHoleTime] = useState(0);
  const [twoStepHoleTimeSec, setTwoStepHoleTimeSec] = useState(0);
  const [twoStepHoleAmt, setTwoStepHoleAmt] = useState(0);

  const [jointCnt, setJointCnt] = useState(0);
  const [jointTimePerSec, setJointTimePerSec] = useState(0);
  const [sagyouTimeJoint, setSagyouTimeJoint] = useState(0);
  const [sagyouAmtJoint, setSagyouAmtJoint] = useState(0);

  const isDandoriDetailOpen = openInputSubDetailKeys.has('kakou-detail-dandori');

  const isBasicDetailOpen = openInputSubDetailKeys.has('kakou-detail-basic');

  const isSagyouDetailOpen = openInputSubDetailKeys.has('kakou-detail-sagyou');

  const isSagyouPunchDetailOpen = openInputSubDetailKeys.has('kakou-detail-sagyou-punch');

  const isSagyouDeliDetailOpen = openInputSubDetailKeys.has('kakou-detail-sagyou-deli');

  const isSagyouMarkDetailOpen = openInputSubDetailKeys.has('kakou-detail-sagyou-mark');

  const isSecondDetailOpen = openInputSubDetailKeys.has('kakou-detail-second');

  const isJointDetailOpen = openInputSubDetailKeys.has('kakou-detail-joint');

  const basicSetupTimeSec = props?.deviceMst?.details?.prepBasicTime;

  //装置の作業時間チャージ
  const mWorkHRate = props?.deviceMst.details?.charges.work;

  //装置の段階時間チャージ
  const mSetHRate = props?.deviceMst.details?.charges.prep;

  //装置の段階時間チャージ
  const twoStepHolework = props?.deviceMst.details?.charges.twoStepHolework;

  //装置の段階時間チャージ
  const jointSeparate = props?.deviceMst.details?.charges.jointSeparate;

  useEffect(() => {
    // レーザー工程入力情報取得
    let processInput = props?.laserData?.processInput?.filter((item) => item.processId == props?.processMst?.id)[0];
    if (processInput) {
      setLaserProcessInput(processInput);
    }
    console.log(props?.estimateData);

    calculatePunchProcessing();
  }, [props?.laserData]);

  const calculatePunchProcessing = () => {
    // 面積
    let area = Number(props?.punchData?.totalSurfaceArea);
    let basicSetupTimeSec = props?.deviceMst?.details?.prepBasicTime;
    setBasicSetupTime(basicSetupTimeSec);
    let danAmtBasic = calDandoriAmt(basicSetupTimeSec);
    setBasicSetupAmt(danAmtBasic);

    let nijiProcessMst = props?.parameters?.process
      ? props?.parameters?.process?.filter(
          (item) => item?.class === ServiceClass.SheetMetal && item.workType === WorkType.SmSecondaryWork
        )[0]
      : [];

    // プログラムの工程入力情報取得
    let punchProcessInput = props?.punchData?.processInput?.filter((item) => item.processId == props?.processMst?.id);

    let secondaryUsedForCalc = props?.punchData?.processSelect?.details?.filter(
      (i) => i.processId === nijiProcessMst?.id
    )?.[0]?.isUsedForCalc;

    // ブランク加工下穴計算有取得
    let settingInfo = props?.settingInfo;
    let isBlankDrillingCalculationFlg = settingInfo?.[0]?.environments?.isBlankDrillingCalculation;

    let secondaryWorkProcessInput;
    let secondaryWorkTypeList = [];
    let nijiCnt = 0;
    if (nijiProcessMst !== undefined) {
      secondaryWorkProcessInput = props?.punchData?.processInput?.filter(
        (item) => item.processId == nijiProcessMst?.id
      )[0];
      if (secondaryWorkProcessInput !== undefined && secondaryWorkProcessInput?.details !== undefined) {
        secondaryWorkProcessInput?.details.forEach((e) => {
          if (Number(e.diameter) > 0) {
            nijiCnt += Number(e.count);
          }
        });
        secondaryWorkTypeList = secondaryWorkTypeGroupLengthCount(secondaryWorkProcessInput?.details, 1);
      }
    }

    let moldQty = 0;
    moldQty = getKanagataCnt(
      props?.deviceMst,
      props?.punchData,
      punchProcessInput?.[0]?.details?.[0]?.quantityList,
      punchProcessInput?.[0]?.details?.[0],
      secondaryUsedForCalc,
      isBlankDrillingCalculationFlg,
      secondaryWorkTypeList
    );

    setDandoriMoldCnt(moldQty);

    // 金型段取金額/時間
    let prepMoldQtyCoeffThMaster = props?.deviceMst?.details?.prepMoldQtyCoeffThMaster?.filter(
      (item) => (item.value == moldQty || item.value > moldQty) && !item.isOutOfRange // IQX_WEBEST-217
    )?.[0];
    let prepMoldQtyCoeffItems = props?.deviceMst?.details?.prepMoldQtyCoeffItems?.filter(
      (item) => item.no == prepMoldQtyCoeffThMaster?.no && !item.isOutOfRange
    )?.[0];
    let moldSetupTimeSec = prepMoldQtyCoeffItems?.value;
    moldSetupTimeSec = moldSetupTimeSec === undefined ? 0 : moldSetupTimeSec;
    setMoldSetupTime(moldSetupTimeSec);
    let danAmtMold = calDandoriAmt(moldSetupTimeSec);
    setMoldSetupAmt(danAmtMold);

    // パンチ加工時間（1パンチ加工時間	*	パンチ数	*	サイズ係数）
    let punchCount = 0;
    punchCount = calPunchCnt(
      punchProcessInput?.[0]?.details?.[0],
      props?.deviceMst,
      isBlankDrillingCalculationFlg,
      nijiCnt
    );

    setPunchCount(punchCount);

    let productionQuantityCoeff = getProductionQuantityCoeff(props?.deviceMst);
    setProductionQuantityCoeff(productionQuantityCoeff);
    //材質
    let materialTypeIq3Id = props?.punchData?.materialTypeIq3Id;
    //材質区分
    let materialTypeId = props?.parameters?.materialTypeIq3?.filter((item) => item.id == materialTypeIq3Id)?.[0]
      ?.materialTypeId;
    // 板厚
    let thickness = props?.parameters?.materialIq3?.filter(
      (item) => item.id == props?.selectedIQ3DataDetail?.thickness
    )?.[0]?.info?.thick;
    // パンチ数
    let punchCnt = punchCount; //確認必要

    let punchTm = getSagyoPunchTm(props?.deviceMst, thickness, materialTypeId);
    setOnePunchTime(punchTm);
    let sagyoTmPunchPerSec = punchTm * punchCnt * productionQuantityCoeff;
    setSagyouPunchTime(sagyoTmPunchPerSec);
    let sagyoPunchAmt = calSagyoAmt(sagyoTmPunchPerSec, props?.deviceMst);
    setSagyouPunchAmt(sagyoPunchAmt);

    // 空送時間（空送距離	/	送り速度）
    let speedAirDeli = props?.deviceMst?.details?.feedSpeed;
    let speedAirDeliLen = Number(punchProcessInput?.[0]?.details?.[0]?.dimensionData?.airFeedDistance);
    setSpeedDeliAirLan(speedAirDeliLen);
    let rawCalc = Number(speedAirDeliLen) / Number(speedAirDeli);

    let sagyoTmAirDeli = Number.isFinite(rawCalc) ? rawCalc : 0;

    setSagyouTmAirDeli(sagyoTmAirDeli);
    let sagyoAirFeedAmt = calSagyoAmt(sagyoTmAirDeli);
    setSagyoAmtAirDeli(sagyoAirFeedAmt);

    let speedScribingLen = Number(punchProcessInput?.[0]?.details?.[0]?.dimensionData?.etchingLength); //PMX用ケガキ線長
    setSpeedScribingLen(speedScribingLen);
    let speedScribing = props?.deviceMst?.details?.workSpeed;
    let scrCal = Number(speedScribingLen) / Number(speedScribing);
    let sagyoTmScribing = Number.isFinite(scrCal) ? scrCal : 0;
    setSagyoTmScribing(sagyoTmScribing);
    let sAmtSubscribing = calSagyoAmt(sagyoTmScribing);
    setSagyoAmtScribing(sAmtSubscribing);

    // 2工程穴加工金額/時間
    let twoStepHoleTm = props?.deviceMst?.details?.twoStepHoleworkTime;
    setTwoStepHoleTimeSec(twoStepHoleTm);
    let twoStepHoleCnt = secondaryUsedForCalc === true ? 0 : nijiCnt;
    setTwoStepHoleCnt(twoStepHoleCnt);
    let twoStepHoleTmsec = twoStepHoleTm * twoStepHoleCnt * productionQuantityCoeff;
    setTwoStepHoleTime(twoStepHoleTime);
    let sagyoAmt2Step = calSagyoAmtTwoStepHole(twoStepHoleTmsec);
    setTwoStepHoleAmt(sagyoAmt2Step);

    // ジョイントバラシ加工金額/時間
    let jointTimePerSec = getJointTm(props?.deviceMst, thickness, materialTypeId);
    setJointTimePerSec(jointTimePerSec);
    let jointQtySizeThMaster = props?.deviceMst?.details?.jointQtySizeThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item.isOutOfRange
    )?.[0];
    jointQtySizeThMaster = jointQtySizeThMaster
      ? jointQtySizeThMaster
      : props?.deviceMst?.details?.jointQtySizeThMaster?.[props?.deviceMst?.details?.jointQtySizeThMaster.length - 1];
    let jointCnt = props?.deviceMst?.details?.jointQtyItems?.filter(
      (item) => item.no == jointQtySizeThMaster?.no && !item.isOutOfRange
    )?.[0]?.value;
    setJointCnt(jointCnt);
    // ジョイントバラシ加工時間	*	個数
    let jointTimeSec = jointTimePerSec * jointCnt * productionQuantityCoeff;
    setSagyouTimeJoint(jointTimeSec);
    let sagyoAmtJoint = calSagyoAmtJoint(jointTimeSec);
    setSagyouAmtJoint(sagyoAmtJoint);
  };

  const calSagyoAmtJoint = (dandoriTimeSec) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;

    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * jointSeparate) / 60.0;
    dandoriAmt = Number.isFinite(dandoriAmt) ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const getJointTm = (deviceMst, thickness, materialTypeIq3Id) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    let jointSeparateThickThMaster = deviceMst?.details?.jointSeparateThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item.isOutOfRange
    )?.[0];

    let jointSeparateItems = Object.entries(deviceMst.details?.jointSeparateItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeIq3Id
    )?.[0];

    // ジョイント時間
    let childPartsCoeff = 0;
    jointSeparateItems?.map((item, index) => {
      if (index > 0) {
        childPartsCoeff = item?.filter(
          (item) => parseInt(item.no) == jointSeparateThickThMaster?.no && !item.isOutOfRange
        )?.[0]?.value;
      }
    });
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const calDandoriAmt = (dandoriTimeSec) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;

    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * mSetHRate) / 60.0;
    dandoriAmt = Number.isFinite(dandoriAmt) ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const calSagyoAmt = (cSagyoTimeKonpoSec) => {
    // 作業金額
    // 作業時間
    let mWorkHTime = cSagyoTimeKonpoSec;
    let mWorkHTimeMin = mWorkHTime / 60;
    //　加工時間＊時間チャージ
    let cSagyoAmtKonpo = (mWorkHTimeMin * mWorkHRate) / 60.0;
    cSagyoAmtKonpo = Number.isFinite(cSagyoAmtKonpo) ? cSagyoAmtKonpo : 0;
    return cSagyoAmtKonpo;
  };

  const calSagyoAmtTwoStepHole = (dandoriTimeSec) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;

    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * twoStepHolework) / 60.0;
    dandoriAmt = Number.isFinite(dandoriAmt) ? dandoriAmt : 0;
    return dandoriAmt;
  };

  // IQX_WEBEST-294 ブランク工程の金型段取時間の参照する値が間違っている
  const getKanagataCnt = (
    deviceMst,
    iq3Info,
    blankTypeList,
    inputArr,
    secondaryUsedForCalc,
    isBlankDrillingCalculationFlg,
    secondaryWorkTypeList
  ) => {
    if (deviceMst == undefined || deviceMst?.length == 0 || deviceMst?.details?.odOvertakeItems == undefined) return 0;
    let kanagataCnt = 0;
    let kanagataType = {
      maru: 0,
      kaku: 0,
      nagakaku: 0,
      other: 0,
      twoPitch: 0,
      overTakingCon: [],
    };
    // 外周使用金型本数のカウント
    // let xSize = Number(iq3Info?.partSizeX); // 矩形サイズX
    // let ySize = Number(iq3Info?.partSizeY); // 矩形サイズY
    // IQX_WEBEST-332 パンチ工程、外径のパンチ数算出方法の変更
    // if ((xSize + ySize) * 2 === Number(inputArr.dimensionData.outerDia)) {
    //   //『（矩形Xサイズ +矩形Yサイズ) * 2 = 外形周長』の場合
    //   // Xサイズの追い抜き条件の加工辺長の値を元に金型情報取得
    //   let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
    //     (item) => (Number(item.value) === xSize || item.value > xSize) && !item?.isOutOfRange
    //   );
    //   let overtakeMold =
    //     overtakeItems?.length > 0
    //       ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
    //       : [deviceMst?.details?.odOvertakeMoldMaster[0]];
    //   kanagataType.overTakingCon.push(overtakeMold[0]);
    //   // Yサイズの追い抜き条件の加工辺長の値を元に金型情報取得
    //   overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
    //     (item) => (Number(item.value) === ySize || item.value > ySize) && !item?.isOutOfRange
    //   );
    //   overtakeMold =
    //     overtakeItems?.length > 0
    //       ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
    //       : [deviceMst?.details?.odOvertakeMoldMaster[0]];
    //   kanagataType.overTakingCon.push(overtakeMold[0]);
    // } else {
    //   //『（矩形Xサイズ +矩形Yサイズ) * 2 != 外形周長』の場合
    //   // 利用金型：「外径周長/４」線長の金型
    //   let outerDiaX = Number(inputArr?.dimensionData?.outerDia) / 4;
    //   let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
    //     (item) => (Number(item.value) === outerDiaX || item.value > outerDiaX) && !item?.isOutOfRange
    //   );
    //   let overtakeMold =
    //     overtakeItems?.length > 0
    //       ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems?.[0]?.no)
    //       : [deviceMst?.details?.odOvertakeMoldMaster[0]];
    //   kanagataType.overTakingCon.push(overtakeMold[0]);
    // }
    let punchesArr = deviceMst?.details?.punches;
    if (props?.selectedIQ3DataDetail?.outerCadItems) {
      const result = groupLengthCount(props?.selectedIQ3DataDetail?.outerCadItems, 1);
      result?.forEach((outerLen) => {
        let twoPitchInfo = props?.selectedIQ3DataDetail?.outerCadItems?.filter((i) => i.length === outerLen.length);
        if (twoPitchInfo?.length > 0 && twoPitchInfo?.[0]?.r !== undefined) {
          kanagataType.overTakingCon.push({ no: 0, name: 'outerTwoPitch', isOutOfRange: false });
        } else {
          // Xサイズのパンチ数取得
          let overtakeItemsOuter = deviceMst?.details?.odOvertakeItems?.filter(
            (item) => (item.value == outerLen.length || item.value > outerLen.length) && !item?.isOutOfRange
          );
          let overtakeMoldOuter =
            overtakeItemsOuter?.length > 0
              ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsOuter[0]?.no)
              : [deviceMst?.details?.odOvertakeMoldMaster[0]];
          kanagataType.overTakingCon.push(overtakeMoldOuter[0]);
        }
      });
    }

    // 内周使用金型本数のカウント
    // パンチ条件
    const sameBlankTypes = new Set();

    for (let i = 0; i < blankTypeList?.length; i++) {
      let item = blankTypeList[i];
      // Set に登録するキーを "types:diameter" 形式にする
      const key = `${item.types}:${item.diameter}`;
      if (
        item.types === 1 &&
        item.diameter !== undefined &&
        item.diameter !== null &&
        Number(item.diameter) !== 0 &&
        !sameBlankTypes.has(key)
      ) {
        // 丸（径を元に決定）
        if (Number(item.diameter) <= Number(punchesArr?.punchHoleDia)) {
          // 丸種類
          kanagataType.maru += 1;
        } else {
          // 二プリング種類
          kanagataType.twoPitch += 1;
        }
      } else if (
        item.types === 2 &&
        item.perimeter !== undefined &&
        item.perimeter !== null &&
        Number(item.perimeter) !== 0 &&
        item.diameter !== undefined &&
        item.diameter !== null &&
        Number(item.diameter) !== 0
      ) {
        // 角（辺長を元に決定）
        if (Number(item.perimeter) <= Number(punchesArr?.punchRectanglePer)) {
          // 角種類
          kanagataType.kaku += 1;
        } else {
          // 追い抜き条件種類
          let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
            (odOvertakeItem) =>
              (Number(odOvertakeItem.value) === Number(item.diameter) ||
                Number(odOvertakeItem.value) > Number(item.diameter)) &&
              !item?.isOutOfRange
          );
          let overtakeMold =
            overtakeItems?.length > 0
              ? deviceMst?.details?.odOvertakeMoldMaster?.filter(
                  (odOvertakeItem) => odOvertakeItem.no === overtakeItems[0]?.no
                )
              : [deviceMst?.details?.odOvertakeMoldMaster[0]];
          kanagataType.overTakingCon.push(overtakeMold[0]);
        }
      } else if (
        item.types === 3 &&
        item.perimeter !== undefined &&
        item.perimeter !== null &&
        Number(item.perimeter) !== 0 &&
        item.xsize !== undefined &&
        item.xsize !== null &&
        Number(item.xsize) !== 0 &&
        item.ysize !== undefined &&
        item.ysize !== null &&
        Number(item.ysize) !== 0
      ) {
        // 長角
        if (Number(item.perimeter) <= Number(punchesArr.punchRectanglePer)) {
          // 長角種類
          kanagataType.nagakaku += 1;
        } else {
          //（XサイズとYサイズを元に決定）
          // Xサイズ（mm）
          // 追い抜き条件種類
          let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
            (odItem) =>
              (Number(odItem?.value) === Number(item.xsize) || Number(odItem?.value) > Number(item.xsize)) &&
              !odItem?.isOutOfRange
          );
          let overtakeMold =
            overtakeItems?.length > 0
              ? deviceMst?.details?.odOvertakeMoldMaster?.filter(
                  (odOvertakeItem) => odOvertakeItem.no === overtakeItems?.[0]?.no
                )
              : [deviceMst?.details?.odOvertakeMoldMaster[0]];
          kanagataType.overTakingCon.push(overtakeMold[0]);

          // Yサイズ（mm）
          // 追い抜き条件種類
          overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
            (odOvertakeItem) =>
              (Number(odOvertakeItem.value) === Number(item.ysize) ||
                Number(odOvertakeItem.value) > Number(item.ysize)) &&
              !odOvertakeItem?.isOutOfRange
          );
          overtakeMold =
            overtakeItems?.length > 0
              ? deviceMst?.details?.odOvertakeMoldMaster?.filter(
                  (odOvertakeItem) => odOvertakeItem.no === overtakeItems?.[0]?.no
                )
              : [deviceMst?.details?.odOvertakeMoldMaster[0]];
          kanagataType.overTakingCon.push(overtakeMold[0]);
        }
      } else if (
        item.types === 4 &&
        item.xsize !== undefined &&
        item.xsize !== null &&
        Number(item.xsize) !== 0 &&
        item.ysize !== undefined &&
        item.ysize !== null &&
        Number(item.ysize) !== 0
      ) {
        // 長丸（XサイズとYサイズを元に決定）
        // let squareXSize = Number(item.xsize) - Number(item.ysize);
        // let overtakeItemsSq = deviceMst?.details?.odOvertakeItems?.filter(
        //   (odOvertakeItem) =>
        //     (Number(odOvertakeItem.value) === squareXSize || Number(odOvertakeItem.value) > squareXSize) &&
        //     !odOvertakeItem?.isOutOfRange
        // );
        // let overtakeMoldSq =
        //   overtakeItemsSq?.length > 0
        //     ? deviceMst?.details?.odOvertakeMoldMaster?.filter(
        //         (odOvertakeItem) => odOvertakeItem.no === overtakeItemsSq[0]?.no
        //       )
        //     : [deviceMst?.details?.odOvertakeMoldMaster[0]];
        // // 追い抜き条件種類
        // kanagataType.overTakingCon.push(overtakeMoldSq[0]); // X線分の追い抜き条件情報
        // // 円弧部分(二プリング種類)
        // kanagataType.twoPitch += 1;
        if (Number(item.xSize) <= Number(punchesArr.punchHoleDia)) {
          kanagataType.twoPitch += 1;
        } else {
          // linesとArcを見て計算。
          let combinedBorderLines = item.combinedBorderLines;
          if (combinedBorderLines?.length > 0) {
            const combinedBorderLinesGroupResult = groupLengthCount(combinedBorderLines, 1);
            combinedBorderLinesGroupResult?.forEach((innerLen) => {
              let perimeter = innerLen.length;
              let inputCnt = innerLen.count;
              let innerTwoPitchInfo = combinedBorderLines?.filter((i) => i.length === perimeter);
              if (innerTwoPitchInfo?.length > 0 && innerTwoPitchInfo?.[0]?.r !== undefined) {
                kanagataType.overTakingCon.push({ no: 0, name: 'innerTwoPitch', isOutOfRange: false });
              } else {
                if (perimeter !== undefined && perimeter !== null && perimeter !== 0) {
                  let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                    (item) => (item.value == perimeter || item.value > perimeter) && !item?.isOutOfRange
                  );

                  let overtakeMoldOuter =
                    overtakeItems?.length > 0
                      ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                      : [deviceMst?.details?.odOvertakeMoldMaster[0]];
                  kanagataType.overTakingCon.push(overtakeMoldOuter[0]);
                }
              }
            });
          } else {
            if (item.perimeter !== undefined && item.perimeter !== null && item.perimeter !== 0) {
              let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                (item) => (item.value == item.perimeter || item.value > item.perimeter) && !item?.isOutOfRange
              );

              let overtakeMoldOuter =
                overtakeItems?.length > 0
                  ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                  : [deviceMst?.details?.odOvertakeMoldMaster[0]];
              kanagataType.overTakingCon.push(overtakeMoldOuter[0]);
            }
          }
        }
      } else if (
        item.types === 5 &&
        item.perimeter !== undefined &&
        item.perimeter !== null &&
        Number(item.perimeter) !== 0
      ) {
        // その他（周長を元に決定）
        // その他種類（R付角、センタポンチ、シングルD、ダブルD）の場合、combinedBorderLinesからの周長を見て計算。
        let combinedBorderLines = item.combinedBorderLines;
        if (combinedBorderLines?.length > 0) {
          const combinedBorderLinesGroupResult = groupLengthCount(combinedBorderLines, 1);
          combinedBorderLinesGroupResult?.forEach((innerLen) => {
            let perimeter = innerLen.length;
            let inputCnt = innerLen.count;
            let innerTwoPitchInfo = combinedBorderLines?.filter((i) => i.length === perimeter);
            if (innerTwoPitchInfo?.length > 0 && innerTwoPitchInfo?.[0]?.r !== undefined) {
              kanagataType.overTakingCon.push({ no: 0, name: 'innerTwoPitch', isOutOfRange: false });
            } else {
              if (perimeter !== undefined && perimeter !== null && perimeter !== 0) {
                let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                  (item) => (item.value == perimeter || item.value > perimeter) && !item?.isOutOfRange
                );

                let overtakeMoldOuter =
                  overtakeItems?.length > 0
                    ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                    : [deviceMst?.details?.odOvertakeMoldMaster[0]];
                kanagataType.overTakingCon.push(overtakeMoldOuter[0]);
              }
            }
          });
        } else {
          if (item.perimeter !== undefined && item.perimeter !== null && item.perimeter !== 0) {
            let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
              (item) => (item.value == item.perimeter || item.value > item.perimeter) && !item?.isOutOfRange
            );

            let overtakeMoldOuter =
              overtakeItems?.length > 0
                ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                : [deviceMst?.details?.odOvertakeMoldMaster[0]];
            kanagataType.overTakingCon.push(overtakeMoldOuter[0]);
          }
        }
      }
      if (!sameBlankTypes.has(key)) {
        sameBlankTypes.add(key);
      }
    }
    // 使用追い抜き条件種類数カウント
    let overTakingConCnt = 0;
    let overTakingConInfo = kanagataType.overTakingCon?.reduce((a, e) => {
      a[e.name] = ++a[e.name] || 0;
      return a;
    }, {});
    if (overTakingConInfo) {
      overTakingConCnt = Object.keys(overTakingConInfo)?.length;
    }
    // 二プリング（不使用時：０，使用時：１）
    if (kanagataType.twoPitch > 0) {
      kanagataType.twoPitch = 1;
    } else {
      kanagataType.twoPitch = 0;
    }
    // 使用金型種類数
    kanagataCnt =
      kanagataType.maru +
      kanagataType.kaku +
      kanagataType.nagakaku +
      kanagataType.other +
      kanagataType.twoPitch +
      overTakingConCnt;

    let secondaryWorkTypeLen =
      secondaryWorkTypeList && secondaryWorkTypeList?.length > 0 ? secondaryWorkTypeList?.length : 0;
    // ブランク加工下穴計算有がONの場合
    if (isBlankDrillingCalculationFlg) {
      // 2次加工がOFFの場合、2次加工種類かつ下穴（2次加工分）をカウントする
      if (secondaryUsedForCalc === false) {
        let secondaryWorkTypePilotHole = secondaryWorkTypeLen;
        kanagataCnt += secondaryWorkTypeLen + secondaryWorkTypePilotHole;
      } else {
        // 2次加工工程がONの場合、下穴（2次加工分）をカウントする
        let secondaryWorkTypePilotHole = secondaryWorkTypeLen;
        kanagataCnt += secondaryWorkTypePilotHole;
      }
    } else {
      // ブランク加工下穴計算有がOFFの場合
      // 2次加工がOFFの場合、2次加工種類をカウントする
      if (secondaryUsedForCalc === false) {
        kanagataCnt += secondaryWorkTypeLen;
      }
    }

    kanagataCnt = kanagataCnt ? kanagataCnt : 0;
    return kanagataCnt;
  };

  const calPunchCnt = (inputArr, deviceMst, isBlankDrillingCalculationFlg, nijiCnt) => {
    let quantityList = inputArr.quantityList;
    let outerDiaX = Number(inputArr.dimensionData.outerDia) / 4;
    let punchCnt = 0;
    let punchesArr = deviceMst?.details?.punches;
    // IQX_WEBEST-332 パンチ工程、外径のパンチ数算出方法の変更
    // let xSize = props?.selectedIQ3DataDetail?.partSizeX ? Number(props?.selectedIQ3DataDetail?.partSizeX) : 0;
    // let ySize = props?.selectedIQ3DataDetail?.partSizeY ? Number(props?.selectedIQ3DataDetail?.partSizeY) : 0;
    // if ((xSize + ySize) * 2 === Number(inputArr.dimensionData.outerDia)) {
    //『（矩形Xサイズ +矩形Yサイズ) * 2= 外形周長』の場合
    // let xPunchCnt = 0;
    // let yPunchCnt = 0;
    // // Xサイズのパンチ数取得
    // let overtakeItemsOuter = deviceMst?.details?.odOvertakeItems?.filter(
    //   (item) => (item.value == xSize || item.value > xSize) && !item?.isOutOfRange
    // );
    // let overtakeMoldOuter =
    //   overtakeItemsOuter?.length > 0
    //     ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsOuter[0]?.no)
    //     : [deviceMst?.details?.odOvertakeMoldMaster[0]];
    // let xOuter = Number(overtakeMoldOuter[0].name.split('x')[0]?.trim());
    // xPunchCnt = Number.isFinite(xSize / (xOuter * 0.95)) ? Math.ceil(xSize / (xOuter * 0.95)) : 0;
    // // Yサイズのパンチ数取得
    // overtakeItemsOuter = deviceMst?.details?.odOvertakeItems?.filter(
    //   (item) => (item.value == ySize || item.value > ySize) && !item?.isOutOfRange
    // );
    // overtakeMoldOuter =
    //   overtakeItemsOuter?.length > 0
    //     ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsOuter[0]?.no)
    //     : [deviceMst?.details?.odOvertakeMoldMaster[0]];
    // let yOuter = Number(overtakeMoldOuter[0].name.split('x')[0]?.trim());
    // yPunchCnt = Number.isFinite(ySize / (yOuter * 0.95)) ? Math.ceil(ySize / (yOuter * 0.95)) : 0;
    // // 外径パンチ数＝（Xサイズのパンチ数＋Yサイズのパンチ数）＊２
    // punchCnt = (xPunchCnt + yPunchCnt) * 2;
    // }
    // else {
    //   // 『（矩形Xサイズ +矩形Yサイズ) * 2 != 外形周長』の場合
    //   let overtakeItemsOuter = deviceMst?.details?.odOvertakeItems?.filter(
    //     (item) => (item.value == outerDiaX || item.value > outerDiaX) && !item?.isOutOfRange
    //   );
    //   let overtakeMoldOuter =
    //     overtakeItemsOuter?.length > 0
    //       ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsOuter[0]?.no)
    //       : [deviceMst?.details?.odOvertakeMoldMaster[0]];
    //   let xOuter = Number(overtakeMoldOuter[0].name.split('x')[0]?.trim());
    //   // 外径パンチ数＝（外径周長/４）のパンチ数＊４
    //   punchCnt = Number.isFinite(outerDiaX / (xOuter * 0.95)) ? Math.ceil(outerDiaX / (xOuter * 0.95)) * 4 : 0;
    // }

    if (props?.selectedIQ3DataDetail?.outerCadItems) {
      const result = groupLengthCount(props?.selectedIQ3DataDetail?.outerCadItems, 1);
      result?.forEach((outerLen) => {
        let xPunchCnt = 0;
        let twoPitchInfo = props?.selectedIQ3DataDetail?.outerCadItems?.filter((i) => i.length === outerLen.length);
        if (twoPitchInfo?.length > 0 && twoPitchInfo?.[0]?.r !== undefined) {
          xPunchCnt = Number.isFinite(outerLen.length / punchesArr?.twoPitch)
            ? Math.trunc(outerLen.length / punchesArr?.twoPitch) + 1
            : 0;
        } else {
          // Xサイズのパンチ数取得
          let overtakeItemsOuter = deviceMst?.details?.odOvertakeItems?.filter(
            (item) => (item.value == outerLen.length || item.value > outerLen.length) && !item?.isOutOfRange
          );
          let overtakeMoldOuter =
            overtakeItemsOuter?.length > 0
              ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsOuter[0]?.no)
              : [deviceMst?.details?.odOvertakeMoldMaster[0]];
          let xOuter = Number(overtakeMoldOuter[0].name.split('x')[0]?.trim());
          xPunchCnt = Number.isFinite(outerLen.length / (xOuter * 0.95))
            ? Math.ceil(outerLen.length / (xOuter * 0.95))
            : 0;
        }
        punchCnt += xPunchCnt * outerLen.count;
      });
    }

    quantityList?.forEach((e) => {
      let perimeter = Number(e.perimeter);
      let xSize = Number(e.xsize);
      let ySize = Number(e.ysize);
      let diameter = Number(e.diameter);
      let inputCnt = Number(e.count);

      switch (e.types) {
        //　穴の場合
        case 1:
          if (
            diameter !== undefined &&
            diameter !== null &&
            perimeter !== undefined &&
            perimeter !== null &&
            perimeter !== 0
          ) {
            if (diameter > punchesArr.punchHoleDia) {
              let count = Number.isFinite(perimeter / punchesArr.twoPitch)
                ? Math.ceil(perimeter / punchesArr.twoPitch) + 1
                : 0;
              punchCnt += count * inputCnt;
            } else {
              punchCnt += inputCnt;
            }
          }
          break;
        case 2:
          // 角の場合
          if (
            diameter !== undefined &&
            diameter !== null &&
            perimeter !== undefined &&
            perimeter !== null &&
            perimeter !== 0
          ) {
            if (perimeter > punchesArr.punchRectanglePer) {
              let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                (item) => (item.value == diameter || item.value > diameter) && !item?.isOutOfRange
              );

              let overtakeMold =
                overtakeItems?.length > 0
                  ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                  : [deviceMst?.details?.odOvertakeMoldMaster[0]];

              let x = Number(overtakeMold[0].name.split('x')[0]);
              let count = Number.isFinite(diameter / (x * 0.95)) ? Math.ceil(diameter / (x * 0.95)) * 4 : 0;
              punchCnt += count * inputCnt;
            } else {
              punchCnt += inputCnt;
            }
          }
          break;
        case 3:
          if (
            xSize !== undefined &&
            xSize !== null &&
            ySize !== undefined &&
            ySize !== null &&
            perimeter !== undefined &&
            perimeter !== null &&
            perimeter !== 0
          ) {
            // 長角の場合
            if (perimeter > punchesArr.punchRectanglePer) {
              let overtakeItemsX = deviceMst?.details?.odOvertakeItems?.filter(
                (item) => (item.value == xSize || item.value > xSize) && !item?.isOutOfRange
              );

              let overtakeMoldX =
                overtakeItemsX?.length > 0
                  ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsX[0]?.no)
                  : [deviceMst?.details?.odOvertakeMoldMaster[0]];

              let x = Number(overtakeMoldX[0].name.split('x')[0]?.trim());

              let resultX = Number.isFinite(xSize / (x * 0.95)) ? Math.ceil(xSize / (x * 0.95)) : 0;

              let overtakeItemsY = deviceMst?.details?.odOvertakeItems?.filter(
                (item) => (item.value == ySize || item.value > ySize) && !item?.isOutOfRange
              );

              let overtakeMoldY =
                overtakeItemsY?.length > 0
                  ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsY[0]?.no)
                  : [deviceMst?.details?.odOvertakeMoldMaster[0]];

              let y = Number(overtakeMoldY[0].name.split('x')[0]?.trim());
              let resultY = Number.isFinite(ySize / (y * 0.95)) ? Math.ceil(ySize / (y * 0.95)) : 0;
              let count = (resultX + resultY) * 2;
              punchCnt += count * inputCnt;
            } else {
              punchCnt += inputCnt;
            }
          }
          break;
        case 4:
          // if (ySize !== undefined && ySize !== null && xSize !== undefined && xSize !== null && perimeter !== 0) {
          //   let squareSize = xSize - ySize;
          //   let overtakeItemsSq = deviceMst?.details?.odOvertakeItems?.filter(
          //     (item) => (item.value == squareSize || item.value > squareSize) && !item?.isOutOfRange
          //   );

          //   let overtakeMoldSq =
          //     overtakeItemsSq?.length > 0
          //       ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItemsSq[0]?.no)
          //       : [deviceMst?.details?.odOvertakeMoldMaster[0]];

          //   let xSq = Number(overtakeMoldSq[0].name.split('x')[0]?.trim());
          //   let count1 = Number.isFinite(squareSize / (xSq * 0.95)) ? Math.ceil((squareSize / (xSq * 0.95)) * 2) : 0;

          //   let count2 = Number.isFinite((ySize * Math.PI) / punchesArr.twoPitch)
          //     ? Math.ceil((ySize * Math.PI) / punchesArr.twoPitch) + 1
          //     : 0;
          //   let count = count1 + count2;
          //   punchCnt += count * inputCnt;
          // }
          // 長丸の場合 // OB,SD,DDは、XL≦mOnePunchHoleは、１パンチとする。
          if (xSize <= punchesArr.punchHoleDia) {
            punchCnt += 1 * inputCnt;
          } else {
            // linesとArcを見て計算。
            let combinedBorderLines = e.combinedBorderLines;
            if (combinedBorderLines?.length > 0) {
              const combinedBorderLinesGroupResult = groupLengthCount(combinedBorderLines, 1);
              combinedBorderLinesGroupResult?.forEach((innerLen) => {
                let perimeter = innerLen.length;
                let inputCnt = innerLen.count;
                let innerTwoPitchInfo = combinedBorderLines?.filter((i) => i.length === perimeter);
                if (innerTwoPitchInfo?.length > 0 && innerTwoPitchInfo?.[0]?.r !== undefined) {
                  let arcPunchCnt = Number.isFinite(perimeter / punchesArr?.twoPitch)
                    ? Math.trunc(perimeter / punchesArr?.twoPitch) + 1
                    : 0;
                  punchCnt += arcPunchCnt * inputCnt;
                } else {
                  if (perimeter !== undefined && perimeter !== null && perimeter !== 0) {
                    let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                      (item) => (item.value == perimeter || item.value > perimeter) && !item?.isOutOfRange
                    );

                    let overtakeMold =
                      overtakeItems?.length > 0
                        ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                        : [deviceMst?.details?.odOvertakeMoldMaster[0]];

                    let x = Number(overtakeMold[0].name.split('x')[0]);
                    let count = Number.isFinite(perimeter / (x * 0.95)) ? Math.ceil(perimeter / (x * 0.95)) : 0;
                    punchCnt += count * inputCnt;
                  }
                }
              });
            } else {
              if (perimeter !== undefined && perimeter !== null && perimeter !== 0) {
                let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                  (item) => (item.value == perimeter || item.value > perimeter) && !item?.isOutOfRange
                );

                let overtakeMold =
                  overtakeItems?.length > 0
                    ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                    : [deviceMst?.details?.odOvertakeMoldMaster[0]];

                let x = Number(overtakeMold[0].name.split('x')[0]);
                let count = Number.isFinite(perimeter / (x * 0.95)) ? Math.ceil(perimeter / (x * 0.95)) : 0;
                punchCnt += count * inputCnt;
              }
            }
          }
          break;
        case 5:
          // その他種類（R付角、センタポンチ、シングルD、ダブルD）の場合、combinedBorderLinesからの周長を見て計算。
          let combinedBorderLines = e.combinedBorderLines;
          if (combinedBorderLines?.length > 0) {
            const combinedBorderLinesGroupResult = groupLengthCount(combinedBorderLines, 1);
            combinedBorderLinesGroupResult?.forEach((innerLen) => {
              let perimeter = innerLen.length;
              let inputCnt = innerLen.count;
              let innerTwoPitchInfo = combinedBorderLines?.filter((i) => i.length === perimeter);
              if (innerTwoPitchInfo?.length > 0 && innerTwoPitchInfo?.[0]?.r !== undefined) {
                let arcPunchCnt = Number.isFinite(perimeter / punchesArr?.twoPitch)
                  ? Math.trunc(perimeter / punchesArr?.twoPitch) + 1
                  : 0;
                punchCnt += arcPunchCnt * inputCnt;
              } else {
                if (perimeter !== undefined && perimeter !== null && perimeter !== 0) {
                  let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                    (item) => (item.value == perimeter || item.value > perimeter) && !item?.isOutOfRange
                  );

                  let overtakeMold =
                    overtakeItems?.length > 0
                      ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                      : [deviceMst?.details?.odOvertakeMoldMaster[0]];

                  let x = Number(overtakeMold[0].name.split('x')[0]);
                  let count = Number.isFinite(perimeter / (x * 0.95)) ? Math.ceil(perimeter / (x * 0.95)) : 0;
                  punchCnt += count * inputCnt;
                }
              }
            });
          } else {
            if (perimeter !== undefined && perimeter !== null && perimeter !== 0) {
              let overtakeItems = deviceMst?.details?.odOvertakeItems?.filter(
                (item) => (item.value == perimeter || item.value > perimeter) && !item?.isOutOfRange
              );

              let overtakeMold =
                overtakeItems?.length > 0
                  ? deviceMst?.details?.odOvertakeMoldMaster?.filter((item) => item.no == overtakeItems[0]?.no)
                  : [deviceMst?.details?.odOvertakeMoldMaster[0]];

              let x = Number(overtakeMold[0].name.split('x')[0]);
              let count = Number.isFinite(perimeter / (x * 0.95)) ? Math.ceil(perimeter / (x * 0.95)) : 0;
              punchCnt += count * inputCnt;
            }
          }

          break;
      }
    });

    // ブランク加工下穴計算有がONの場合
    if (isBlankDrillingCalculationFlg) {
      // 2次加工がON・OFFの場合、下穴（2次加工分）をカウントする
      punchCnt += nijiCnt;
    }

    punchCnt = punchCnt ? punchCnt : 0;
    return punchCnt;
  };

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.selectedEstimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.selectedIQ3DataDetail?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  const getSagyoPunchTm = (deviceMst, thickness, materialTypeIq3Id) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 加工速度
    let punchWorkTimeThickThMaster = deviceMst?.details?.punchWorkTimeThickThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item.isOutOfRange
    )?.[0];

    let punchWorkTimeItems = Object.entries(deviceMst.details?.punchWorkTimeItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeIq3Id
    )?.[0];

    // 加工速度
    let childPartsCoeff = 0;
    punchWorkTimeItems?.map((item, index) => {
      if (index > 0) {
        childPartsCoeff = item?.filter(
          (item) => parseInt(item.no) == punchWorkTimeThickThMaster?.no && !item.isOutOfRange
        )?.[0]?.value;
      }
    });
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const groupLengthCount = (data, precision = 1) => {
    const groups = {};

    data?.forEach((item) => {
      // length を丸めてキーにする
      // const key = item.length.toFixed(precision);
      const key = item.length;
      if (!groups[key]) {
        groups[key] = 0;
      }
      groups[key]++;
    });

    return Object.entries(groups)?.map(([length, count]) => ({
      length: parseFloat(length),
      count,
    }));
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };

  const toggleInputSubDetail = (parentKey, index) => {
    const key = `${parentKey}-${index}`;
    setOpenInputSubDetailKeys((prevKeys) => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key);
      } else {
        newKeys.add(key);
      }
      return newKeys;
    });
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => toggleInputSubDetail('kakou-detail', 'dandori')}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isDandoriDetailOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'段取金額/時間'}</label>
        </Col>
      </Row>

      {isDandoriDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'段取時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'段取金額'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div>
                  <label>{'基本段取金額/時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${basicSetupTime} (${secondsToHms(basicSetupTime)})`}</label>
                </div>

                <div>
                  <label>{`${basicSetupTime} × ${mSetHRate} = ${JPYs.format(Math.round(basicSetupAmt))}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isDandoriDetailOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'basic')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isBasicDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'金型段取金額/時間'}</label>
          </Col>
        </Row>
      </div>
      {isDandoriDetailOpen && isBasicDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'金型段取時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'金型段取金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'使用金型本数'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'金型段取時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'金型段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'使用金型本数'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${moldSetupTime} (${secondsToHms(moldSetupTime)})`}</label>
                </div>

                <div>
                  <label>{`${moldSetupAmt} × ${mSetHRate} = ${JPYs.format(Math.round(moldSetupAmt))}`}</label>
                </div>

                <div>
                  <label>{`${dandoriMoldCnt}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => toggleInputSubDetail('kakou-detail', 'sagyou')}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isSagyouDetailOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>

      <div style={{ display: isSagyouDetailOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'sagyou-punch')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isSagyouPunchDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'パンチ加工金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isSagyouDetailOpen && isSagyouPunchDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'パンチ加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'パンチ加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'パンチ数/1パンチ加工時間'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'パンチ加工時間 x パンチ数 x サイズ係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'パンチ加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'パンチ数/1パンチ加工時間'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${onePunchTime} x ${punchCount} x ${productionQuantityCoeff} = ${sagyouPunchTime} (${secondsToHms(
                    sagyouPunchTime
                  )})`}</label>
                </div>

                <div>
                  <label>{`${sagyouPunchTime} × ${mWorkHRate} = ${JPYs.format(Math.round(sagyouPunchAmt))}`}</label>
                </div>

                <div>
                  <label>{`${onePunchTime}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isSagyouDetailOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'sagyou-deli')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isSagyouDeliDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'空送金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isSagyouDetailOpen && isSagyouDeliDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送速度/空送距離'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'空送速度/空送距離'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${sagyoTmAirDeli} (${secondsToHms(sagyoTmAirDeli)})`}</label>
                </div>

                <div>
                  <label>{`${sagyoTmAirDeli} × ${mWorkHRate} = ${JPYs.format(Math.round(sagyoAmtAirDeli))}`}</label>
                </div>

                <div>
                  <label>{`${speedDeliAirLan}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <div style={{ display: isSagyouDetailOpen ? 'block' : 'none', marginLeft: 10 }}>
        <Row
          style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
          onClick={() => toggleInputSubDetail('kakou-detail', 'sagyou-mark')}
        >
          <Col span={10} style={{ paddingLeft: 30 }}>
            {isSagyouMarkDetailOpen ? (
              <CaretUpOutlined style={{ fontSize: 18 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18 }} />
            )}
            <label style={{ marginLeft: 5 }}>{'ケガキ加工金額/時間'}</label>
          </Col>
        </Row>
      </div>

      {isSagyouDetailOpen && isSagyouMarkDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工速度/切断長'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ケガキ加工速度/切断長'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{` ${sagyoTmScribing} (${secondsToHms(sagyoTmScribing)})`}</label>
                </div>

                <div>
                  <label>{`${sagyoTmScribing} × ${mWorkHRate} = ${JPYs.format(Math.round(sagyoAmtScribing))}`}</label>
                </div>

                <div>
                  <label>{`${speedScribingLen}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => toggleInputSubDetail('kakou-detail', 'second')}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isSecondDetailOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'2工程穴加工金額/時間'}</label>
        </Col>
      </Row>

      {isSecondDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量/1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工時間 x 個数 x サイズ係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'2工程穴加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量/1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${twoStepHoleTimeSec} x ${twoStepHoleCnt} x ${productionQuantityCoeff} = ${twoStepHoleTime} (${secondsToHms(
                    twoStepHoleTime
                  )})`}</label>
                </div>

                <div>
                  <label>{`${twoStepHoleTime} × ${twoStepHolework} = ${JPYs.format(
                    Math.round(twoStepHoleAmt)
                  )}`}</label>
                </div>

                <div>
                  <label>{`${twoStepHoleCnt}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => toggleInputSubDetail('kakou-detail', 'joint')}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isJointDetailOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'ジョイントバラシ加工金額/時間'}</label>
        </Col>
      </Row>

      {isJointDetailOpen && (
        <div>
          <div>
            <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
              <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工時間'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工金額'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量/1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={12} style={{ paddingTop: 10 }}>
                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工時間 x 個数 x サイズ係数'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'ジョイントバラシ加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                </div>

                <div
                  style={{
                    borderBottom: '2px solid #eeebeb',
                    paddingBottom: 4,
                  }}
                >
                  <label>{'数量/1つ当たりの加工時間'}</label>
                </div>
              </Col>
              <Col span={8} style={{ paddingTop: 10 }}>
                <div>
                  <label>{`${jointTimePerSec} x ${jointCnt} x ${productionQuantityCoeff} = ${sagyouTimeJoint} (${secondsToHms(
                    sagyouTimeJoint
                  )})`}</label>
                </div>

                <div>
                  <label>{`${sagyouTimeJoint} × ${jointSeparate} = ${JPYs.format(Math.round(sagyouAmtJoint))}`}</label>
                </div>

                <div>
                  <label>{`${jointCnt}`}</label>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_BlankPunch;
